import { render } from "./VirtualPanelsView.vue?vue&type=template&id=6aedca17&scoped=true"
import script from "./VirtualPanelsView.vue?vue&type=script&lang=js"
export * from "./VirtualPanelsView.vue?vue&type=script&lang=js"

import "./VirtualPanelsView.vue?vue&type=style&index=0&id=6aedca17&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aedca17"]])

export default __exports__